/* UTM pass-through, same keys as the landing (src/utm.js there): the first
   utm_* set seen in this browser session is kept in sessionStorage and
   written into the sign-up metadata by EmailGate. The landing forwards the
   parameters on the terminal URL. */
const KEY = 'w3k_utm';
const FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export function captureUtm() {
  try {
    const q = new URLSearchParams(window.location.search);
    const found = {};
    FIELDS.forEach(f => { const v = q.get(f); if (v) found[f] = v.slice(0, 120); });
    if (Object.keys(found).length && !sessionStorage.getItem(KEY)) {
      sessionStorage.setItem(KEY, JSON.stringify(found));
    }
  } catch { /* storage blocked — UTM is best effort */ }
}

export function getUtm() {
  try { return JSON.parse(sessionStorage.getItem(KEY) || 'null') || {}; } catch { return {}; }
}
